<template>
    <div class="list">
		<div class="item" v-for="(item,i) in list" :key="i">
			<router-link :to="`/exhibit-detail-${item.id}`" target="_blank">
				<el-image fit="cover" class="image" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
				<p>{{item.title}}</p>
			</router-link>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "list4",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			list: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
.list{
	display: flex;
	// flex-flow: wrap;
	.item:first-child{
		margin-left: 0;
	}
	.item{
		// display: block;
		width: 32%;
		margin-left: 2%;
		overflow: hidden;
		.image{
			width: 100%;
			height: 100px;
		}
		p{
			// padding: 5px;
			width: 100%;
			display: block;
			overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
			line-height: 30px;
			text-align: center;
			// font-size: 33;
		}
	}
}
</style>
